import { render } from "./Breadcrumb.vue?vue&type=template&id=6ec6d73a&scoped=true&ts=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"

import "./Breadcrumb.vue?vue&type=style&index=0&id=6ec6d73a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec6d73a"]])

export default __exports__